import { post } from '../axios'

// 删除问题
export function faq_deleteQa_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/deleteQa`, map, option).then(
    response => response
  )
}

// 删除标题
export function faq_deleteTitle_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/deleteTitle`, map, option).then(
    response => response
  )
}

// 修改问题顺序
export function faq_modifyPosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_FAQ}/faq/modifyPosition`,
    map,
    option
  ).then(response => response)
}

// 查询标题下问题列表
export function faq_queryQa_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/queryQa`, map, option).then(
    response => response
  )
}

// 查询标题列表
export function faq_queryTitle_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/queryTitle`, map, option).then(
    response => response
  )
}

// 新增/编辑问题
export function faq_upsertQa_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/upsertQa`, map, option).then(
    response => response
  )
}

// 新增/编辑标题
export function faq_upsertTitle_post(map, option) {
  return post(`${process.env.VUE_APP_FAQ}/faq/upsertTitle`, map, option).then(
    response => response
  )
}

// 修改标题顺序
export function faq_modifyTitlePosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_FAQ}/faq/modifyTitlePosition`,
    map,
    option
  ).then(response => response)
}
